export const tokenStorageKey = 'gallyToken'
